import { inject, injectable } from 'inversify';

import {
  TUseUserTenantAgnosticRoles,
  TUseUserTenantSpecificRoles,
} from '../domain/interfaces';
import { UserHookFactory } from '../infrastructure/factories/User.hook.factory';

@injectable()
export class UserHookService {
  constructor(
    @inject(UserHookFactory) private readonly userHookFactory: UserHookFactory,
  ) {}

  public readonly composeUseUserTenantSpecificRoles =
    (): TUseUserTenantSpecificRoles => {
      return this.userHookFactory.composeUseUserTenantSpecificRoles();
    };

  public readonly composeUseUserTenantAgnosticRoles =
    (): TUseUserTenantAgnosticRoles => {
      return this.userHookFactory.composeUseUserTenantAgnosticRoles();
    };
}
